import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import { getDefaultRoute } from 'utils/roleAccess';

/**
 * Redirects the user to their role-appropriate landing page.
 * Waits for profile to load before redirecting.
 */
const DefaultRedirect: React.FC = () => {
  const { auth } = useAuth();

  // Wait until user profile is fully loaded before computing default route
  if (auth.isLoading || !auth.user || !auth.user.accountProfile) {
    return null;
  }

  return <Navigate replace to={getDefaultRoute(auth.user)} />;
};

export default DefaultRedirect;
